export default __webpack_public_path__ + "static/media/saveFilledIcon.55f61a14.svg";